import React, { createContext, useContext, useEffect, useRef, useState } from 'react'
import { CreateSchoolStyles } from './Style'
import { Title as ScreenTitle } from 'components'
import { useLocation, useParams } from 'react-router-dom'
import { queryOptions, useQuery } from '@tanstack/react-query'
import { getAffiliationFetch, getInvalidStudentsFileFetch, getLearningGroupFetch, getSchoolClassesFetch } from 'store/middlewares/affiliation.crud'
import { useDispatch } from 'react-redux'
import { initialize, reset } from 'redux-form'
import { useSelector } from 'react-redux'
import { genderHebrewKeys } from 'keys/gender'
import { keyBy, uniqueId } from 'lodash'
import { AbilityContext } from 'components/Permissions/Can'
import { affiliationGroups } from 'keys'
import { TabComponent } from '.'
import * as XLSX from 'xlsx';
import qc from 'keys/queryClient'
import allClassess from "mock/classess"
import dayjs from 'dayjs'
import { getCurrentSchoolYear } from 'utils/general'

const CreateSchoolContent = (props) => {
    let formname = "affiliationCrud"
    const dispatch = useDispatch()
    const ability = useContext(AbilityContext)
    const isSuperuser = ability.can("manage", "super-user")
    const { languages } = useSelector(state => state.static)
    const { groups } = useSelector(state => state.affiliation)

    const { affiliationID } = useParams()
    const institutionCode = useRef()
    const { state } = useLocation()
    const params = useParams()

    const [selectedTab, setSelectedTab] = useState(state?.tabIndex || 0)
    const [rowOpen, setRowOpen] = useState(null)
    const [isFormEditing, setIsFormEditing] = useState(!affiliationID)
    const [gradeOpen, setGradeOpen] = useState(null)
    const [searchVal, setSearchVal] = useState("")
    const [institutionCodeApproved, setInstitutionCodeApproved] = useState(affiliationID ? true : false)
    const [classIndexTab, setClassIndexTab] = useState(0)
    const [classIndexTab1, setClassIndexTab1] = useState(0)
    const [invalidTestTakers, setInvalidTestTakers] = useState([])
    const [affiliationGroup, setAffiliationGroup] = useState(params?.affiliationGroupID)
    const [learningGroup, setLearningGroup] = useState(null)

    const [promoteYear, setPromoteYear] = useState(getCurrentSchoolYear())
    const [promoteSelection, setPromoteSelection] = useState({})
    const [promoteSelectedGradeId, setPromoteSelectedGradeId] = useState(null)
    const [classStudentsCache, setClassStudentsCache] = useState({})

    const groupsById = keyBy(groups, "id")
    const isSchoolsGroup = groupsById?.[affiliationGroup]?.name == affiliationGroups.schools

    const affiliation = useQuery({
        queryKey: [qc.affiliation, affiliationID],
        queryFn: async () => {
            const { data } = await getAffiliationFetch(affiliationID)
            setAffiliationGroup(data.group)
            return data
        },
        enabled: !!affiliationID
    })

    // שנת הלימודים הנצפית נשלטת ע"י promoteYear (DD "העלאת כיתה") - ברירת מחדל: השנה הנוכחית
    const schoolClassGradesOptions = queryOptions({
        queryKey: [qc.affiliationGrades, affiliationID, promoteYear],
        queryFn: async () => {
            const { data } = await getSchoolClassesFetch(affiliationID, promoteYear)
            return data
        },
        enabled: !!affiliationID && isSchoolsGroup
    })
    // מכוון לשנת הלימודים הנכחית, אפשר לראות בקריאת שרת עצמה שמעבירים שנת לימודים
    const learningGroupsOptions = queryOptions({
        queryKey: [qc.learningGroups, affiliationID],
        queryFn: async () => {
            const { data } = await getLearningGroupFetch(affiliationID)
            return data
        },
        enabled: !!affiliationID && !isSchoolsGroup
    })

    const schoolClassGrades = useQuery(schoolClassGradesOptions)
    const learningGroups = useQuery(learningGroupsOptions)

    const currentGrade = schoolClassGrades?.data?.find(item => item.id == gradeOpen) || []
    const schoolClass = currentGrade.classes?.[classIndexTab]

    const invalidStudentFile = useQuery({
        queryKey: [qc.studentFile, schoolClass?.id, schoolClass?.invalid_students_file],
        queryFn: async () => {
            if (schoolClass.invalid_students_file) {
                const { data: fileData } = await getInvalidStudentsFileFetch(schoolClass?.id)
                const reader = new FileReader()
                reader.onload = (event) => {
                    const binaryStr = event.target.result;
                    const workbook = XLSX.read(binaryStr, { type: 'binary' });
                    const sheetName = workbook.SheetNames[0]; // בחר את הגיליון הראשון
                    const worksheet = workbook.Sheets[sheetName];
                    const jsonData = XLSX.utils.sheet_to_json(worksheet);
                    const renamedData = jsonData.map((item, index) => {
                        return {
                            // חשוב מאד לשים לב ששמות העמודות מתואמות עם הקאסל העדכני ועם השרת, אחרת הלוגיקה לא תעבוד
                            id: uniqueId(),
                            serial_number_row_file: index,
                            first_name: item['שם פרטי'],
                            last_name: item['שם משפחה'],
                            test_taker_name: item['שם פרטי'] + " " + item['שם משפחה'],
                            tz: item['תעודת זהות'],
                            gender: genderHebrewKeys?.[item['מגדר']],
                            language: item['שפה עיקרית בבית'] ? languages?.find(la => la.label == item['שפה עיקרית בבית']) : null,
                            invalid: true,
                            dob: item['תאריך לידה'] ? dayjs(new Date((item['תאריך לידה'] - 25569) * 86400 * 1000)) : null,
                            parent_first_name: item['שם הורה'],
                            parent_last_name: item['משפחה הורה'],
                            parent_phone: item['טלפון הורה לקבלת SMS'],
                            parent_email: item['מייל הורה'],
                            
                            home_affiliation: affiliation.data,
                            home_grade: currentGrade?.id,
                            home_class: allClassess.find(item => item.name == schoolClass.name)?.id
                        }
                    });
                    setInvalidTestTakers(renamedData)
                };
                reader.readAsBinaryString(fileData)
            }
            else {
                setInvalidTestTakers([])
            }
            return null
        },
        enabled: !!(schoolClass?.id)
    })

    const commonValue = {
        formname,
        affiliation,
        institutionCode,
        selectedTab, setSelectedTab,
        rowOpen, setRowOpen,
        gradeOpen, setGradeOpen,
        searchVal, setSearchVal,
        classIndexTab, setClassIndexTab,
        classIndexTab1, setClassIndexTab1,
        schoolClassGrades, schoolClassGradesOptions,
        invalidStudentFile,
        institutionCodeApproved, setInstitutionCodeApproved,
        invalidTestTakers, setInvalidTestTakers,
        isSchoolsGroup,
        affiliationGroup,
        learningGroup, setLearningGroup,
        isFormEditing, setIsFormEditing,
        affiliationGroupItem: groupsById?.[affiliationGroup],
        learningGroups, learningGroupsOptions,
        promoteYear, setPromoteYear,
        promoteSelection, setPromoteSelection,
        promoteSelectedGradeId, setPromoteSelectedGradeId,
        classStudentsCache, setClassStudentsCache
    }

    // מעבר שנה ב-DD מאפס את הבחירה הנוכחית - כדי שלא יישאר שיוך מבולבל בין שנים
    useEffect(() => {
        setPromoteSelection({})
        setPromoteSelectedGradeId(null)
        setClassStudentsCache({})
    }, [promoteYear])

    useEffect(() => {
        return (() => {
            dispatch(reset(formname))
            dispatch(initialize(formname, {}));
        })
    }, [])

    const title = isSchoolsGroup ? "הוספת בית ספר" : "הוספת לקוח"

    return (
        <SchoolContext.Provider value={commonValue}>
            <CreateSchoolStyles>
                <ScreenTitle {...props} breadcrumbs={isSuperuser}>
                    <div className='bread-crumbs-title'>
                        {"> "}
                        {affiliationID ? affiliation.data?.name : title}
                    </div>
                </ScreenTitle>
                <TabComponent />
            </CreateSchoolStyles>
        </SchoolContext.Provider>
    )
}

export const SchoolContext = createContext()
export default CreateSchoolContent